// extracted by mini-css-extract-plugin
export var buttonContainer = "_64-1";
export var fontSizeSelect = "_64-3";
export var formatSelect = "_64-2";
export var formats = "_64-4";
export var hidden = "_64-5";
export var icon = "_64-6";
export var select = "_64-0";